import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import classNames from 'classnames';

import { HighRiskSupplement } from '@models/highRiskSupplement';
import formatDate from '@utils/formatDate';

import WarningTypeItemWithTooltip from '../WarningTypeItemWithTooltip/WarningTypeItemWithTooltip';

import './style.scss';

interface IProps {
  data: HighRiskSupplement;
  isActive: boolean;
  onClick: (data: HighRiskSupplement) => void;
}

// HRS stands for High Risk Supplements
const HRSItemCard: FC<IProps> = ({ data, isActive, onClick }): JSX.Element => {
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(data);
    }
  }, [onClick, data]);

  return (
    <Box
      className={classNames('hrs-item-card__section', {
        'hrs-item-card__section--active': isActive,
      })}
      onClick={handleClick}
    >
      <Box
        className={classNames('hrs-item-card__icon', {
          'hrs-item-card__icon--default': !data.image,
        })}
      >
        {data.image && (
          <Box component="img" src={data.image.url} className="hrs-item-card__image" />
        )}
        {!data.image && (
          <Box
            component="img"
            src="/images/img-grid-view.svg"
            className="hrs-item-card__default-image"
          />
        )}
      </Box>

      <Box className="hrs-item-card__content">
        <h3 className="hrs-item-card__title">{data.name}</h3>
        {data.warningTypes.map(warningType => (
          <WarningTypeItemWithTooltip data={warningType} />
        ))}
        {data.company && <p className="hrs-item-card__text">{data.company}</p>}
        {data.statusDate && <p className="hrs-item-card__text">{formatDate(data.statusDate)}</p>}
      </Box>
    </Box>
  );
};

export default HRSItemCard;
